module.exports = __webpack_public_path__ + "static/media/figure10.15469933.png";